module.exports = __webpack_public_path__ + "15dbded820912a1534e04bebf980f0dd.png";